import Vue from 'vue'

Vue.config.errorHandler = function (err, vm, info) {
  const nuxtError = {
    statusCode: err.statusCode || err.name || 'Whoops!',
    message: err.message || err.toString(),
    stack: err.stack
  }

  // Show Nuxt Error Page
  if (vm && vm.$root && vm.$root.$nuxt && vm.$root.$nuxt.error && info !== 'render function') {
    vm.$root.$nuxt.error(nuxtError)
  }

  // Log to console
  if (process.env.NODE_ENV !== 'production') {
    console.error(err)
  } else {
    console.error(err.message || nuxtError.message)
  }
}
